import { BASE_URL } from '../../../../../utils/config.base-url'

export const DOCUMENT_CATEGORY_PREFIX_URL = '/document-category'
export const URL_ENDPOINT_DOCUMENT_CATEGORY = `${BASE_URL}/document-category`
